<template>
  <div class="animated fadeIn bgV2">
    <b-row>
      <b-col md="12">
        <gofix-tab
                class="mt-3"
                :data="tabData">
          <template slot="gofixTab:right">
            <gofix-button
                    class="mr-3"
                    label="RAISE A CASE"
                    :loading="isAction"></gofix-button>
            <gofix-button
                    label="Save"
                    :loading="isAction"></gofix-button>
          </template>
          <template slot="gofixTab:basic-info">
            <b-form>
              <gofix-card classContent="mb-0 mt-4">
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <div class="field">
                          <label class="text-right">#</label>
                          <div class="info-right">00001</div>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <div class="field">
                          <label>Case Number</label>
                          <div class="info-right text-decoration-underline">CA-ABC-1909-0001</div>
                        </div>
                      </b-col>
                      <b-col md="3">
                        <gofix-form-dropdown
                                label="Status"
                                :options="['Reported', 'Acknowledged', 'Case raised', 'Closed']">
                        </gofix-form-dropdown>
                      </b-col>
                      <b-col md="3">
                        <div class="field">
                          <label>Remarks</label>
                          <div class="info-right">none</div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </gofix-card>
              <gofix-card classContent="mb-0 mt-4">
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <gofix-form-dropdown
                                label="Feedback Nature"
                                :options="['General Enquiries', 'Business Enquiries', 'Individual Enquiries', 'Complaint', 'Compliment', 'Safety Incident', 'Work Request']">
                        </gofix-form-dropdown>
                      </b-col>
                      <b-col md="3">
                        <gofix-form-tree
                                label="Service Category"
                                :options="dataService"
                                :normalizer="normalizer"
                                valueFormat="object">
                        </gofix-form-tree>
                      </b-col>
                      <b-col md="3">
                        <gofix-form-dropdown
                                label="Fault Type"
                                v-model="payment.status"
                                :options="['1', '2', '3']">
                        </gofix-form-dropdown>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="6">
                        <gofix-form-tree
                                label="Location"
                                :options="dataProperty"
                                :normalizer="normalizer"
                                valueFormat="object">
                        </gofix-form-tree>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-tree
                                label="Equipment"
                                :options="dataEquipment"
                                :normalizer="normalizer"
                                valueFormat="object">
                        </gofix-form-tree>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="6">
                        <gofix-form-input label="Description"></gofix-form-input>
                      </b-col>
                      <b-col md="6">
                        <div class="field">
                          <div class="d-flex justify-content-between align-items-center">
                            <label class="m-0">Related Feedback</label>
                            <gofix-button label="Edit" @click="modalRelatedFeedback" noBorder fontNormal small></gofix-button>
                          </div>
                          <div class="info-right">00002, 00003</div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </gofix-card>
              <gofix-card classContent="mb-0 mt-4">
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <gofix-form-dropdown
                                label="Salutation"
                                v-model="payment.status"
                                :options="['1', '2', '3']">
                        </gofix-form-dropdown>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-input label="Name"></gofix-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <gofix-form-input label="Reqestor Type"></gofix-form-input>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-dropdown
                                label="Company"
                                v-model="payment.status"
                                :options="['1', '2', '3']">
                        </gofix-form-dropdown>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <gofix-form-input label="Phone Number"></gofix-form-input>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-input label="Email"></gofix-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="11">
                    <b-row>
                      <b-col md="3">
                        <gofix-form-dropdown
                                label="Prefer Contact By"
                                v-model="payment.status"
                                :options="['1', '2', '3']">
                        </gofix-form-dropdown>
                      </b-col>
                      <b-col md="6">
                        <gofix-form-dropdown
                                label="Contact Type"
                                v-model="payment.status"
                                :options="['1', '2', '3']">
                        </gofix-form-dropdown>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </gofix-card>
            </b-form>
          </template>
        </gofix-tab>
      </b-col>
    </b-row>
    <b-modal :no-close-on-backdrop="true" id="modal-select-invoice" title="Related Feedback" hide-footer :centered="true" ref="modal-related-feedback">
      <b-row class="content">
        <b-col md="12">
          <div class="scollingTable">
            <b-table :fields="fields" @row-clicked="" :items="relatedFeedback">
              <!-- <template slot="HEAD_actions" scope="foo">
                <b-form-checkbox class="uniform" @input="toggleSelected" name="invoice" v-model="allSelected"></b-form-checkbox>
              </template> -->
              <template slot="actions" slot-scope="row">
                <b-form-checkbox :value="row.item.id" v-model="selected"></b-form-checkbox>
              </template>
              <template slot="date" slot-scope="row">
                {{ row.item.date | formatDate }}
              </template>
            </b-table>
          </div>
          <b-button-group class="d-block text-right">
            <gofix-button label="SUBMIT" noBorder></gofix-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Close Status" hide-footer :centered="true" ref="modal-remarks">
      <b-form class="pb-20">
        <b-row>
          <b-col md="12">
            <gofix-form-input label="Remarks"></gofix-form-input>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right">
        <gofix-button label="SUBMIT" noBorder></gofix-button>
      </b-button-group>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';
const accounting = require('accounting');

export default {
  name: 'feedback-detail',
  components: {},
  data() {
    return {
      tabData:[
        {
          key: "basic-info",
          title: "Basic Info",
          active: true
        },
      ],
      dataService: [],
      dataProperty: [],
      dataEquipment: [],
      relatedFeedback: [
        {
          id: '00002',
          location: 'Marina Barrage >> DPS Building >> Maintenance Office >> Corridor',
          service_category: 'ACMV',
          date: '2019-10-01 10:20',
        },
        {
          id: '00003',
          location: 'Marina Barrage >> DPS Building >> Maintenance Office >> Corridor',
          service_category: 'ACMV',
          date: '2019-10-02 10:20',
        },
        {
          id: '00004',
          location: 'Marina Barrage >> DPS Building >> Maintenance Office',
          service_category: 'Electrical',
          date: '2019-10-04 10:20',
        }
      ],
      formats: {
        input: ['DD.MM.YYYY'],
      },
      mode: 'single',
      allSelected: false,
      selected: [],
      activeClass: false,
      fields: [
        {
          key: 'actions',
          label: '',
          thClass: 'checkbox-column text-center',
          tdClass: 'checkbox-column text-center',
          thStyle: "width:50px",
          isActive: 1
        },
        {
          key: 'id',
          label: '#',
          thStyle: "width:70px"
        },
        {
          key: 'location',
          label: 'Location',
          thStyle: "width:100px"
        },
        {
          key: 'service_category',
          label: 'Service Category',
          thStyle: "width:100px"
        },
        {
          key: 'date',
          label: 'Date',
          thStyle: "width:100px"
        }
      ],
      isAction: false,
    }
  },
  filters: {
    formatMoney(value) {
      if(!value) return '-';
      return accounting.formatMoney(value, {
        format: {
          pos : "%s %v",
          neg : "%s (%v)",
          zero: "--"
        }
      });
    },
    formatDate(value) {
      if(!value) return '';
      return moment(value, "YYYY-MM-DD HH:mm:ss").format('DD.MM.YYYY HH:mm');
    },
    priceItems: function (data,method,f){
      let amount = 0;
      let gst = 0;
      let total = 0;
      for (let item of data) {
        amount += parseFloat(item.amount);
        gst += parseFloat(item.gst);
        total += parseFloat(item.total);
      }
      if(method === "amount" ) {
        return f.formatMoney(amount);
      }
      if(method === "gst" ) {
        return f.formatMoney(gst);
      }
      return f.formatMoney(total);
    }
  },
  watch: {
    selected: function(val) {
      if(this.payment.pv_line_items.length > val.length) {
        this.allSelected = false
        return
      }
      if(val.length > 0 && this.payment.pv_line_items.length == val.length) {
        this.allSelected = true
      }
    },
    selectedInvoice: function(val) {
      let arr = this.invoices.map(item => {
        if(item.pv_line_item == null || (item.pv_line_item && item.pv_line_item != null && item.pv_line_item.payment_voucher_id == this.payment.id && !this.payment.ap_invoice_ids.includes(item.id))) {
          return item;
        }
        return null;
      }).filter(Boolean);

      if(arr.length > val.length) {
        this.allSelectedInvoice = false
        return
      }

      if(val.length > 0 && arr.length == val.length) {
        this.allSelectedInvoice = true
      }
    },
  },
  computed: {
    ...mapGetters({
      UserLogin: "AuthController/user",
      payment: "PaymentVoucherController/Payment",
      loadings: "PaymentVoucherController/Loading",
    }),
  },
  async created() {
  },
  methods: {
    modalRelatedFeedback() {
      this.$refs['modal-related-feedback'].show();
    },
    save() {

    },
    normalizer(node) {
      if (node.data.isBatch)
        return {
          id: node.data.id,
          label: node.device_tag,
          children: node.children,
        };
        return {
          id: node.data.id,
          label: node.device_tag,
          children: undefined
        };
    },
    toggleSelected() {
      if (this.allSelected) {
        this.selected = [];
        let i = (this.page.limit * this.page.currentPage - this.page.limit)
        for (i in this.payment.pv_line_items) {
          if(i == this.page.limit) return
          this.selected.push(this.payment.pv_line_items[i].id)
        }
        return
      }
      if(!this.allSelected) {
        this.selected = []
      }
    },
    filterActive() {
      this.activeClass = !this.activeClass
    }
  }
}
</script>
